import React from "react";

export default class Loading extends React.Component {
    render() {
        return (
            <div style={{
                position:"absolute",
                top:0,
                width:"100vw",
                height:"100vh",
                zIndex:10,
                backgroundColor:"rgba(0,0,0,0.3)",
                left:0,
                right:0,
                bottom:0
            }}>

            <h1>LOADING...</h1>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/Loading.js